import {
    statutCommercialisationDossierEnum,
    typeCandidatureEnum
} from '../modules/changementAppartement/enums/changementAppartementEnum'
import portals from '../enums/portalsEnum'
import {DossierModel} from '../types/dossier/dossierModel'

const possedeDossierValide = (dossier: DossierModel | null) => {

    // Si le dossier n'est pas en bail définitif, refusé ou annulé
    if (dossier
        && dossier.statuscode !== statutCommercialisationDossierEnum.definitive
        && dossier.statuscode !== statutCommercialisationDossierEnum.refused
        && dossier.statuscode !== statutCommercialisationDossierEnum.abandoned) {
        // Vérification du type de candidature lié au dossier, si la valeur est 2 / 3 / 4 ou 5
        if (dossier.eft_type_de_candidature !== typeCandidatureEnum.premiereLocation) {
            // Si l'utilisateur est un preneur et qu'il est sur le portail résidence
            if (process.env.REACT_APP_TARGET === portals.residence) {
                return true
            }
        }
    }

    return false
}

export default possedeDossierValide